import React, { useState } from 'react';

const GroupedSelect = ({ value, onChange, options, placeholder }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [openGroups, setOpenGroups] = useState({});

    const toggleGroup = (groupName) => {
        setOpenGroups(prev => ({
            ...prev,
            [groupName]: !prev[groupName]
        }));
    };

    const handleSelect = (option) => {
        onChange(option.value);
        setIsOpen(false);
    };

    // Находим выбранное значение среди всех групп
    const findSelectedOption = () => {
        if (!value) return null;
        
        for (const group of Object.values(options)) {
            const found = group.find(opt => opt.value === value);
            if (found) return found;
        }
        return null;
    };

    const selectedOption = findSelectedOption();

    return (
        <div className="relative min-w-[150px] text-white">
            <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                className="w-full p-2 text-left bg-[#1E1E1E] border border-[#3E3E42] rounded focus:outline-none focus:border-[#007ACC] text-white"
            >
                {selectedOption ? selectedOption.label : placeholder}
            </button>

            {isOpen && (
                <div className="absolute z-10 w-full mt-1 bg-[#1E1E1E] border border-[#3E3E42] rounded shadow-lg">
                    <button
                        type="button"
                        onClick={() => handleSelect({ value: '', label: 'Не назначен' })}
                        className="w-full p-2 text-left hover:bg-[#2D2D30] border-b border-[#3E3E42] text-white"
                    >
                        Не назначен
                    </button>
                    {Object.entries(options).map(([groupName, groupOptions]) => (
                        <div key={groupName} className="border-b border-[#3E3E42] last:border-b-0">
                            <button
                                type="button"
                                onClick={() => toggleGroup(groupName)}
                                className="w-full p-2 text-left bg-[#252526] hover:bg-[#2D2D30] text-white"
                            >
                                {groupName}
                            </button>
                            {openGroups[groupName] && (
                                <div className="pl-4">
                                    {groupOptions.map(option => (
                                        <button
                                            key={option.value}
                                            type="button"
                                            onClick={() => handleSelect(option)}
                                            className="w-full p-2 text-left hover:bg-[#2D2D30] text-white"
                                        >
                                            {option.label}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default GroupedSelect; 